import { create } from 'zustand';

interface UIState {
  sidebarOpen: boolean;
  modalOpen: boolean;
  modalContent: React.ReactNode | null;
  confirmDialogOpen: boolean;
  confirmDialogConfig: ConfirmDialogConfig | null;
  toggleSidebar: () => void;
  openModal: (content: React.ReactNode) => void;
  closeModal: () => void;
  openConfirmDialog: (config: ConfirmDialogConfig) => void;
  closeConfirmDialog: () => void;
}

export interface ConfirmDialogConfig {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel?: () => void;
  variant?: 'danger' | 'warning' | 'info';
}

export const useUIStore = create<UIState>((set) => ({
  sidebarOpen: true,
  modalOpen: false,
  modalContent: null,
  confirmDialogOpen: false,
  confirmDialogConfig: null,

  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),

  openModal: (content) => set({ modalOpen: true, modalContent: content }),

  closeModal: () => set({ modalOpen: false, modalContent: null }),

  openConfirmDialog: (config) => set({ confirmDialogOpen: true, confirmDialogConfig: config }),

  closeConfirmDialog: () => set({ confirmDialogOpen: false, confirmDialogConfig: null }),
}));
